"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nilToNull = void 0;
require("../../lib/bcdice/opal");
Opal.config.unsupported_features_severity = 'ignore';
exports.default = Opal;
function nilToNull(value) {
    return value === Opal.nil ? null : value;
}
exports.nilToNull = nilToNull;
//# sourceMappingURL=opal.js.map